import BackArrow from "./BackArrow";

const ForwardArrow = () => {
  return <BackArrow style={{ transform: "rotateY(180deg)" }} />;
};

export default ForwardArrow;
